/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TiktokAdsService {
    /**
     * Connect a Tiktok Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Tiktok Ads account
     * @throws ApiError
     */
    public static postTiktokAdsConnect(
        workspaceId: string,
        requestBody: {
            name: string;
            client_id?: string;
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tiktok_ads/connect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Tiktok Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully disconnected a Tiktok Ads account
     * @throws ApiError
     */
    public static postTiktokAdsDisconnect(
        workspaceId: string,
        requestBody: {
            ad_account_id: string;
            client_id?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tiktok_ads/disconnect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Save a Tiktok token
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully saved user token
     * @throws ApiError
     */
    public static postTiktokAdsToken(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tiktok_ads/token',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List available to connect Tiktok Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List available to connect Tiktok Ads accounts
     * @throws ApiError
     */
    public static getTiktokAdsAvailable(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tiktok_ads/available',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Tiktok Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Tiktok Ads accounts
     * @throws ApiError
     */
    public static getTiktokAdsConnected(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tiktok_ads/connected',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
